@use '../../ui-library/styles/icon' as icon;
@use '../../ui-library/styles/text' as text;

.errorIcon {
  color: icon.$icon-error;
}

.description {
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: text.$text-tertiary;
}

.error {
  color: text.$text-error;
}

.logoutButton {
  margin-top: 8px;
}
